"use strict";

class Ajaxinate {
  constructor(config) {
    const givenConfig = config || {};
    const defaultConfig = {
      pagination: ".AjaxinatePagination",
      method: "scroll",
      container: ".AjaxinateLoop",
      offset: 0,
      loadingText: "Loading",
      callback: null,
    };
    this.settings = Object.assign(defaultConfig, givenConfig);
    this.addScrollListeners = this.addScrollListeners.bind(this);
    this.addClickListener = this.addClickListener.bind(this);
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
    this.destroy = this.destroy.bind(this);
    this.containerElement = document.querySelector(this.settings.container);
    this.paginationElement = document.querySelector(this.settings.pagination);
    this.initialize();
  }

  initialize() {
    if (this.containerElement) {
      const methods = {
        click: this.addClickListener,
        scroll: this.addScrollListeners,
      };
      methods[this.settings.method]();
    }
  }

  addScrollListeners() {
    if (this.paginationElement) {
      document.addEventListener("scroll", this.checkIfPaginationInView);
      window.addEventListener("resize", this.checkIfPaginationInView);
      window.addEventListener("orientationchange", this.checkIfPaginationInView);
    }
  }

  addClickListener() {
    if (this.paginationElement) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");
      this.clickActive = true;
      if (this.nextPageLinkElement !== null) {
        this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
      }
    }
  }

  stopMultipleClicks(e) {
    e.preventDefault();
    if (this.clickActive) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.clickActive = false;
      this.loadMore();
    }
  }

  checkIfPaginationInView() {
    const top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
    const bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");
      this.removeScrollListener();
      if (this.nextPageLinkElement) {
        this.nextPageLinkElement.innerHTML = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.loadMore();
      }
    }
  }

  async loadMore() {
    try {
      const response = await fetch(this.nextPageUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'text/html',
          'Accept': 'text/html',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContainer = doc.querySelector(this.settings.container);
      const newPagination = doc.querySelector(this.settings.pagination);

      this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;

      if (this.settings.callback && typeof this.settings.callback === "function") {
        this.settings.callback(doc);
      }

      this.initialize();
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
    }
  }

  removeClickListener() {
    this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
  }

  removeScrollListener() {
    document.removeEventListener("scroll", this.checkIfPaginationInView);
    window.removeEventListener("resize", this.checkIfPaginationInView);
    window.removeEventListener("orientationchange", this.checkIfPaginationInView);
  }

  destroy() {
    const methods = {
      click: this.removeClickListener,
      scroll: this.removeScrollListener,
    };
    methods[this.settings.method]();
    return this;
  }
}
